<template>
    <div class="company" v-if="isShow">
        <Commondtitle title="公司介绍" />
        <div class="co_des">
            <div class="co_d_left">
                <h2>{{ dataArr[0].fcompanyName2 }}<br>{{ dataArr[0].fcompanyName3 }}</h2>
                <p v-html="dataArr[0].fdes"></p>
            </div>
            <div class="co_d_right">
                <img :src="IMGURL + dataArr[0].fimageUrl" alt="">
            </div>
        </div>
        <commondtitle title="企业资质" />
        <ul class="co_imgs">
            <li
                v-for="(item,index) in dataArr[0].fileList2"
                @click="bigImg(item)"
                :key="index">
                <img :src="IMGURL + item" alt="">
                <div class="co_i_bg">
                    <p>专项设计</p>
                    <i>查看大图</i>
                </div>
            </li>
        </ul>
    </div>
</template>

<script>
    import Commondtitle from '../Commondtitle'
    import axios from '../../assets/js/baseaxios'
    import baseUrl from '../../assets/js/baseUrl'
    import {
        Pictures
    } from '../../assets/js/tool'
    export default {
        name: "company",
        data(){
            return{
                isShow: false,
                IMGURL: '',
                dataArr: [],
            }
        },
        mounted(){
            this.IMGURL = baseUrl.IMG_URL
            this.getData()

        },
        methods:{
            getData(){
                axios.get(`/api/company`).then(res=>{
                    if(res.data.success){
                        let items = res.data.items
                        items[0].fcompanyName2 = items[0].fcompanyName.slice(0,4)
                        items[0].fcompanyName3 = items[0].fcompanyName.slice(4)
                        items[0].fileList2 = items[0].fileList.split(',')
                        items[0].fileList2 = items[0].fileList2.filter(btn=>{
                            return btn.length !== 0
                        })
                        this.dataArr = items
                        this.isShow = true
                    }else{
                        this.$message.warning(res.data.msg)
                    }
                })
            },
            bigImg(url){
                let val = this.IMGURL + url
                new Pictures(val)
            }
        },
        components:{
            Commondtitle
        }
    }
</script>

<style scoped>
    .company{
        width: 100%;
    }
    .co_des{
        width: 1100px;
        height: 318px;
        margin: 0 auto;
        padding-bottom: 40px;
    }
    .co_d_left{
        float: left;
        width: 550px;
        height: 100%;
    }
    .co_d_left h2{
        font-size: 30px;
        line-height: 40px;
        color: #333;
        font-weight: normal;
        margin-bottom: 50px;
    }
    .co_d_left p{
        width: 450px;
        color: #999;
        font-size: 14px;
        line-height: 19px;
    }
    .co_d_right{
        float: left;
        width: 550px;
        height: 318px;
        position: relative;
        overflow: hidden;
    }
    .co_d_right img{
        position: absolute;
        width: 100%;
        top: 50%;
        transform: translateY(-50%);
    }
    .co_imgs{
        display: flex;
        width: 1100px;
        margin: 0 auto 30px;
        justify-content: flex-start;
        flex-wrap:wrap;
    }
    .co_imgs li{
        position: relative;
        width: 330px;
        height: 465px;
        margin-bottom: 70px;
        margin-right: 55px;
        overflow: hidden;
    }
    .co_imgs li:nth-child(3n){
        margin-right: 0;
    }
    .co_imgs li img{
        position: absolute;
        /*left:50%;*/
        width: 100%;
        top:50%;
        transform: translateY(-50%);
    }
    .co_imgs li .co_i_bg{
        display: none;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        padding: 10px;
        background-color: rgba(0,0,0,.7);
    }
    .co_imgs li:hover .co_i_bg{
        display: block;
    }
    .co_imgs li .co_i_bg p{
        width: 100%;
        height: 100%;
        font-size: 14px;
        color: #00B76B;
        box-sizing: border-box;
        padding: 20px;
        border: 2px solid#00B76B;
    }
    .co_imgs li .co_i_bg i{
        position: absolute;
        top: 50%;
        left: 50%;
        color: #fff;
        font-size: 14px;
        font-style: normal;
        transform: translate(-50%,-50%);
        cursor:pointer;
    }
</style>